import React from 'react';

export default function FontStyleControl({
  selectedItem,
  setRegular,
  toggleBold,
  toggleItalic,
}) {
  return (
    <div className="flex items-center gap-1 rounded-2xl bg-white shadow-sm p-1">
      <button
        type="button"
        onClick={setRegular}
        title="Regular (reset)"
        className={
          (selectedItem.fontWeight ?? 'normal') === 'normal' &&
          (selectedItem.fontStyle ?? 'normal') === 'normal'
            ? 'px-2 py-1 rounded-xl text-sm bg-stone-200'
            : 'px-2 py-1 rounded-xl text-sm hover:bg-stone-100'
        }
      >
        Reg
      </button>
      <button
        type="button"
        onClick={toggleBold}
        title="Bold (Cmd/Ctrl+B)"
        className={
          (selectedItem.fontWeight ?? 'normal') === 'bold'
            ? 'px-2 py-1 rounded-xl text-sm font-semibold bg-stone-200'
            : 'px-2 py-1 rounded-xl text-sm font-semibold hover:bg-stone-100'
        }
        style={{ fontWeight: 'bold' }}
      >
        B
      </button>
      <button
        type="button"
        onClick={toggleItalic}
        title="Italic (Cmd/Ctrl+I)"
        className={
          (selectedItem.fontStyle ?? 'normal') === 'italic'
            ? 'px-2 py-1 rounded-xl text-sm italic bg-stone-200'
            : 'px-2 py-1 rounded-xl text-sm italic hover:bg-stone-100'
        }
        style={{ fontStyle: 'italic' }}
      >
        I
      </button>
    </div>
  );
}
